import { useTranslation } from 'react-i18next';
import flagFR from '../../assets/images/fr.png';
import flagGB from '../../assets/images/gb.png';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const isFr = i18n.language.startsWith('fr');
  const target = isFr ? 'en' : 'fr';

  const handleSwitch = () => {
    i18n.changeLanguage(target);
    localStorage.setItem('i18nextLng', target);
  };

  const label = isFr ? 'Switch to English' : 'Passer en français';

  return (
    <button
      className="language-switcher-btn"
      onClick={handleSwitch}
      aria-label={label}
      title={label}
      style={{ background: 'transparent', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', borderColor: '#fff' }}
    >
      <img
        src={isFr ? flagGB : flagFR}
        alt={isFr ? 'EN' : 'FR'}
        style={{
          borderRadius: '3px',
          display: 'block',
          width: '22px',
          height: '15px',
          maxWidth: 'none'
        }}
      />
    </button>
  );
}
